import { CanActivateFn, Router } from '@angular/router';
import { WorkflowService } from '../services/workflow.service';
import { inject } from '@angular/core';

export const insuranceGuard: CanActivateFn = () => {
  const currentRoute = inject(WorkflowService).currentRoute;
  return currentRoute === 'patient-insurance' ? true : inject(Router).navigate(['/']);
};
